(function () {
    'use strict';

    function simpleSearch(searchDataService, searchService,
        $log, $timeout, $window, $rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/simpleSearch.html',
            transclude: true,
            scope: {
                results: '=',
                uri: '@',
                pageSize: '@',
                searchFieldName: '@',
                searchCondition: '@',
                searchFieldPrompt: '@',
                defaultOrderBy: '@',
                defaultOrderByDirection: '@',
                datasetName: '@'
            },
            link: function (scope, element, attrs) {
                scope.isLoading = true;
                scope.queryModel = {
                    uri: scope.uri,
                    pageSize: scope.pageSize,
                    pageNum: 0,
                    numPages: 0,
                    orderBy: scope.defaultOrderBy,
                    orderByDirection: scope.defaultOrderByDirection.toLowerCase(),
                    predicates: {},
                    injectedPredicates: []
                };

                scope.showPager = attrs.showPager != undefined;
                scope.allowPageSizeChange = attrs.allowPageSizeChange != undefined;
                scope.enableSearchBox = true;
                scope.getAllResults = attrs.getAllResults != undefined;

                if (scope.getAllResults) {
                    scope.queryModel.getAllResults = true;
                }

                if (scope.showPager) {
                    $timeout(function() {
                        scope.pagerElement = $(element).find('.simple-search-results-container');
                    });
                }

                if (scope.searchFieldName && scope.searchFieldPrompt && scope.searchCondition) {
                    scope.queryModel.predicates[scope.searchFieldName] = {
                        value: null,
                        condition: scope.searchCondition,
                        watch: function () { return true; }
                    };
                }
                else if (!scope.searchFieldName && !scope.searchFieldPrompt && !scope.searchCondition) {
                    scope.enableSearchBox = false;
                }
                else {
                    scope.enableSearchBox = true;
                    $log.warn('Invalid configuration for simpleSearch. Must provide searchFieldName, searchFieldPrompt and searchCondition');
                }

                scope.pageSizes = [5, 10, 15, 20, 25];

                scope.$watch(function () { return scope.queryModel; },
                    function (newVal, oldVal) {
                        if (oldVal && oldVal.pageNum >= 0 && oldVal.pageSize >= 0) {
                            if ((oldVal.pageNum !== newVal.pageNum) ||
                                (oldVal.pageSize !== newVal.pageSize)) {
                                scope.pagerEvent = true;
                            }
                        }
                        console.log('get results: ' + scope.datasetName + '| page ' + scope.queryModel.pageNum);
                        getSearchResults(scope.queryModel);
                        scope.resultsReady = true;
                    }, true);

                function getSearchResults() {
                    scope.isLoading = true;
                    scope.canInfiniteScroll = false;
                    searchDataService.getResults(scope.queryModel).then(function (data) {
                        if (!scope.firstDataLoad) {
                            scope.dataLoaded = true;
                            // if (scope.pagerEvent && !append) {
                            //     $timeout(function() {
                            //         // scroll to top of grid
                            //         if (scope.pagerElement) {
                            //             var offset = $(scope.pagerElement).offset();
                            //             // TODO: make configurable
                            //             $window.scroll(offset.left, offset.top - 100);
                            //             scope.pagerEvent = false;
                            //         }
                            //     });
                            // }
                        }
                        scope.results = scope.isAppending ? scope.results.concat(data.Results) : data.Results;
                        scope.totalItems = data.TotalResults;
                        scope.isLoading = false;
                        scope.isAllDataLoaded = scope.results.length === data.TotalResults;

                        if (scope.datasetName && scope.isAllDataLoaded) {
                            $rootScope.$emit('noMoreResults', { datasetName: scope.datasetName });
                        }
                    });

                    scope.attributes = searchService.getAttributes(scope.queryModel.predicates);
                }


                if (scope.datasetName) {
                    $rootScope.$on('getNextResults', function (event, args) {
                        if (args.datasetName === scope.datasetName) {
                            scope.isAppending = true;
                            scope.queryModel.pageNum += 1;
                        }
                    })
                }
            }
        };
    }

    simpleSearch.$inject = ['searchDataService', 'searchService',
        '$log', '$timeout', '$window', '$rootScope'];

    angular.module('ecap.common').directive('simpleSearch', simpleSearch);
})();